import React from 'react';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system';
import Logo from 'design-system/Logo';
import Text from 'design-system/Text';
import FormattedAnnualReturn from './FormattedAnnualReturn';
const StockAssetRow = ({ iconUrl = '', name = '', description, shortDescription, averageAnnualReturn, style, }) => {
    const desc = shortDescription || description;
    return (<View style={[styles.row, style]}>
      <Logo R44 uri={iconUrl} resizeMode="contain"/>
      <View style={styles.flex}>
        <Text Text-16 numberOfLines={1}>
          {name}
        </Text>
        {!!desc && (<Text TextThin-14 Secondary numberOfLines={2}>
            {desc}
          </Text>)}
      </View>
      {!!averageAnnualReturn && (<View style={styles.right}>
          <FormattedAnnualReturn aar={averageAnnualReturn}/>
        </View>)}
    </View>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: rem(16),
        gap: rem(16),
    },
    flex: {
        flex: 1,
    },
    right: {
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
});
export default React.memo(StockAssetRow);
